import { Skeleton } from "@mui/material";
import useTitanApp from "@/hooks/useTitanApp";

export default function PrescriptionImagePreviewSkeleton() {
  const { appState } = useTitanApp();
  const { darkMode } = appState;
  const isDarkMode = darkMode;

  const skeletonSx = { bgcolor: isDarkMode ? "grey.800" : "" };

  return (
    <div className="p-4 space-y-4">
      <Skeleton
        animation="wave"
        variant="rectangular"
        width="100%"
        height={500}
        className="rounded-lg"
        sx={skeletonSx}
      />
    </div>
  );
}
